import { Search } from "lucide-react";
import React from "react";
import { Button, createStyles, TextInput } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  controls: {
    display: "flex",
    marginTop: theme.spacing.xl,
  },

  inputWrapper: {
    width: "100%",
    flex: "1",
  },

  input: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderRight: 0,
  },

  control: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
}));

type SearchBarProps = {
  search: string;
  onSearch: () => void;
  onSearchChange: React.Dispatch<React.SetStateAction<string>>;
};

const SearchBar: React.FC<SearchBarProps> = ({
  search,
  onSearch,
  onSearchChange,
}) => {
  const { classes } = useStyles();

  return (
    <TextInput
      autoFocus
      required
      radius="md"
      size="md"
      style={{
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        borderRight: "none",
      }}
      onChange={({ target }) => onSearchChange(target.value)}
      value={search}
      icon={<Search size={18} />}
      rightSectionWidth={88}
      placeholder="search..."
      rightSection={
        <Button
          color="jem-theme"
          style={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            height: "43px",
          }}
          className={classes.control}
          onClick={onSearch}
        >
          Search
        </Button>
      }
    />
  );
};

export default SearchBar;
